import FiddleDepsProvider from '~providers/fiddle-dependencies';
import * as React from 'react';
export default {
  FiddleDepsProvider,
  React
};